import { CheckOutlined, LeftOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Divider, Flex, Form, Image, Row, Select, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import NumberInput from "../../../../components/inputs/numberInput";
import TableComponent from "../../../../components/table/tableComponent";
import { ConfiguracaoResultadoSorteioModel } from "../../../../models/configuracaoResultadoSorteio/configuracaoResultadoSorteioModel";
import { ConfiguracaoResultadoSorteioVMModel } from "../../../../models/configuracaoResultadoSorteio/configuracaoResultadoSorteioVMModel";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { setPageConfiguracaoResultadoSorteio } from "../../../../redux/slices/configuracaoResultadoSorteio/configuracaoResultadoSorteioSlice";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import {
  atualizarConfiguracaoResultadoSorteio,
  buscarUltimaDataSorteioConfiguracao,
  cadastrarConfiguracaoResultadoSorteio,
  listarConfiguracaoResultadoSorteio,
} from "../../../../services/configuracaoResultadoSorteioService";
import { formatPercent } from "../../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { toastWarning } from "../../../../util/toast";

dayjs.locale("pt-br");

const CadastrarPage = () => {
  //estados globais
  const configuracaoResultadoSorteioState = useAppSelector((state) => state.configuracaoResultadoSorteio);

  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<ConfiguracaoResultadoSorteioVMModel>();
  const [dataEnable, setDataEnable] = useState<boolean>(false);

  const fetchData = async () => {
    const retorno = await dispatch(buscarUltimaDataSorteioConfiguracao(configuracaoResultadoSorteioState.entity.idEmpresa));
    if (retorno.payload !== null && configuracaoResultadoSorteioState.editar) {
      setDataEnable(true);
      form.setFieldValue("dataInicio", dayjs(new Date(retorno.payload.ultimaData)));
    } else {
      if (configuracaoResultadoSorteioState.entity.dataInicio !== null) {
        form.setFieldValue("dataInicio", dayjs(new Date(configuracaoResultadoSorteioState.entity.dataInicio)));
      }
    }
  };

  useEffect(() => {
    dispatch(setTitle(configuracaoResultadoSorteioState.editar ? "EDITAR CONFIGURAÇÕES DE PONTO DE EQUILÍBRIO" : "CADASTRAR CONFIGURAÇÕES DE PONTO DE EQUILÍBRIO"));
    dispatch(listarConfiguracaoResultadoSorteio(configuracaoResultadoSorteioState.entity.idEmpresa));
    form.setFieldsValue({
      idEmpresa: configuracaoResultadoSorteioState.entity.idEmpresa,
      percentualBonificacao_Entidade: configuracaoResultadoSorteioState.entity.percentualBonificacao_Entidade * 100,
      percentualDA_Capitalizacao: configuracaoResultadoSorteioState.entity.percentualDA_Capitalizacao * 100,
      percentualImpostoRessarcimentoPrejuizo_Capitalizacao: configuracaoResultadoSorteioState.entity.percentualImpostoRessarcimentoPrejuizo_Capitalizacao * 100,
      percentualPromocaoVendaRevendedor: configuracaoResultadoSorteioState.entity.percentualPromocaoVendaRevendedor * 100,
      percentualRessarcimentoEncargos_Capitalizacao: configuracaoResultadoSorteioState.entity.percentualRessarcimentoEncargos_Capitalizacao * 100,
      percentualResultado_Entidade: configuracaoResultadoSorteioState.entity.percentualResultado_Entidade * 100,
      percentualRevendedor_Capitalizacao: configuracaoResultadoSorteioState.entity.percentualRevendedor_Capitalizacao * 100,
    });
    fetchData();
  }, [configuracaoResultadoSorteioState.entity]);

  const submit = (value: any) => {
    var submitConfig: ConfiguracaoResultadoSorteioModel = {
      id: null,
      idEmpresa: value.idEmpresa,
      percentualBonificacao_Entidade: value.percentualBonificacao_Entidade / 100,
      percentualDA_Capitalizacao: value.percentualDA_Capitalizacao / 100,
      percentualImpostoRessarcimentoPrejuizo_Capitalizacao: value.percentualImpostoRessarcimentoPrejuizo_Capitalizacao / 100,
      percentualPromocaoVendaRevendedor: value.percentualPromocaoVendaRevendedor / 100,
      percentualRessarcimentoEncargos_Capitalizacao: value.percentualRessarcimentoEncargos_Capitalizacao / 100,
      percentualResultado_Entidade: value.percentualResultado_Entidade / 100,
      percentualRevendedor_Capitalizacao: value.percentualRevendedor_Capitalizacao / 100,
      dataInicio: value.dataInicio,
      dataFim: null,
      idConfiguracaoResultadoSorteio: null,
    };
    if (configuracaoResultadoSorteioState.editar) {
      dispatch(
        atualizarConfiguracaoResultadoSorteio({
          value: {
            ...submitConfig,
            id: configuracaoResultadoSorteioState.entity.id,
          },
          busca: null,
        }),
      );
    } else {
      const submitDataInicio = submitConfig.dataInicio ? new Date(submitConfig.dataInicio) : null;
      const entityDataInicio = configuracaoResultadoSorteioState.entity.dataInicio ? new Date(configuracaoResultadoSorteioState.entity.dataInicio) : null;
      if (submitDataInicio?.getTime() !== entityDataInicio?.getTime()) {
        dispatch(cadastrarConfiguracaoResultadoSorteio({ value: submitConfig, busca: null }));
      } else {
        toastWarning("Ao cadastrar uma nova configuração, é necessário garantir que a data de início seja diferente da configuração anteriormente cadastrada.");
      }
    }
  };

  const voltar = () => {
    dispatch(setTitle("CONFIGURAÇÕES DE RESULTADO DO SORTEIO"));
    dispatch(setPageConfiguracaoResultadoSorteio("geral"));
  };

  const columns: ColumnsType<ConfiguracaoResultadoSorteioModel> = [
    {
      title: "Data Início",
      dataIndex: "dataInicio",
      render: (dataInicio: Date) => <>{dataInicio && dayjs(dataInicio).format("DD/MM/YYYY")}</>,
    },
    {
      title: "Data Fim",
      dataIndex: "dataFim",
      render: (dataFim: Date) => <>{dataFim && dayjs(dataFim).format("DD/MM/YYYY")}</>,
    },
    {
      title: "% Promoção Venda/Revendedor",
      dataIndex: "percentualPromocaoVendaRevendedor",
      render: (_, { percentualPromocaoVendaRevendedor }) => formatPercent(percentualPromocaoVendaRevendedor),
    },
    {
      title: "% Bonificação",
      dataIndex: "percentualBonificacao_Entidade",
      render: (_, { percentualBonificacao_Entidade }) => formatPercent(percentualBonificacao_Entidade),
    },
    {
      title: "% Resultado",
      dataIndex: "percentualResultado_Entidade",
      render: (_, { percentualResultado_Entidade }) => formatPercent(percentualResultado_Entidade),
    },
    {
      title: "% Capitalização",
      dataIndex: "percentualDA_Capitalizacao",
      render: (_, { percentualDA_Capitalizacao }) => formatPercent(percentualDA_Capitalizacao),
    },
    {
      title: "% Ressarcimento de encargos",
      dataIndex: "percentualRessarcimentoEncargos_Capitalizacao",
      render: (_, { percentualRessarcimentoEncargos_Capitalizacao }) => formatPercent(percentualRessarcimentoEncargos_Capitalizacao),
    },
    {
      title: "% Imposto ressarcimento de prejuízo",
      dataIndex: "percentualImpostoRessarcimentoPrejuizo_Capitalizacao",
      render: (_, { percentualImpostoRessarcimentoPrejuizo_Capitalizacao }) => formatPercent(percentualImpostoRessarcimentoPrejuizo_Capitalizacao),
    },
    {
      title: "% Revendedor",
      dataIndex: "percentualRevendedor_Capitalizacao",
      render: (_, { percentualRevendedor_Capitalizacao }) => formatPercent(percentualRevendedor_Capitalizacao),
    },
  ];

  return (
    <Flex gap={12} vertical>
      <Flex onClick={voltar} className="voltar">
        {"<"} VOLTAR
      </Flex>
      <Form layout="vertical" form={form} onFinish={submit}>
        <Row gutter={12} style={{ width: 1100 }}>
          <Col span={7}>
            <Form.Item label="Empresa" name="idEmpresa">
              <Select
                showSearch
                optionFilterProp="labelSearch"
                loading={empresaState.loading}
                style={{ width: "100%" }}
                options={empresaState.list.map((a: EmpresaModel) => ({
                  value: a.id,
                  key: a.apelido,
                  label: (
                    <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                      <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                      {a.apelido}
                    </Flex>
                  ),
                  labelSearch: a.apelido,
                }))}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Data Início" name="dataInicio">
              <DatePicker format={"DD/MM/YYYY"} disabled={dataEnable} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="% Promoção Venda/Revendedor" name="percentualPromocaoVendaRevendedor">
              <NumberInput tipo="p" precisao={4} style={{ width: 250, textAlign: "right" }} />
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left" orientationMargin="0">
          Entidade
        </Divider>
        <Row gutter={12} style={{ width: 1100 }}>
          <Col span={6}>
            <Form.Item label="% Bonificação" name="percentualBonificacao_Entidade">
              <NumberInput tipo="p" precisao={4} style={{ width: 250, textAlign: "right" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="% Resultado" name="percentualResultado_Entidade">
              <NumberInput tipo="p" precisao={4} style={{ width: 250, textAlign: "right" }} />
            </Form.Item>
          </Col>
        </Row>
        <Divider orientation="left" orientationMargin="0">
          Capitalização
        </Divider>
        <Row gutter={12} style={{ width: 1100 }}>
          <Col span={6}>
            <Form.Item label="% Capitalização" name="percentualDA_Capitalizacao">
              <NumberInput tipo="p" precisao={4} style={{ width: 250, textAlign: "right" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="% Ressarcimento de encargos" name="percentualRessarcimentoEncargos_Capitalizacao">
              <NumberInput tipo="p" precisao={4} style={{ width: 250, textAlign: "right" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="% Imposto ressarcimento de prejuízo" name="percentualImpostoRessarcimentoPrejuizo_Capitalizacao">
              <NumberInput tipo="p" precisao={4} style={{ width: 250, textAlign: "right" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="% Revendedor" name="percentualRevendedor_Capitalizacao">
              <NumberInput tipo="p" precisao={4} style={{ width: 250, textAlign: "right" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24} className="modalFooter">
            <Space size="middle">
              <Button className="cancelButton" onClick={voltar} icon={<LeftOutlined />}>
                VOLTAR
              </Button>
              <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
                {!configuracaoResultadoSorteioState.editar ? "SALVAR" : "ATUALIZAR"}
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
      <Divider orientation="left" orientationMargin="0">
        Histórico
      </Divider>
      <TableComponent data={configuracaoResultadoSorteioState.listHistorico} columns={columns} loading={configuracaoResultadoSorteioState.loadingHistorico} />
    </Flex>
  );
};

export default CadastrarPage;
